import hsBgAlert from '../../assets/images/hs_bg_alert.png';
import bannerBg1 from '../../assets/images/banner_bg_orange4.png';

export const useStyles = () => ({
	textGreen: {
		fontSize: 36,
		lineHeight: '48px',
		color: '#28d799',
	},
	saleTimerBanner: {
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat', 
		background: `#181E22 url(${hsBgAlert})`,
		position: 'relative',
		cursor: 'pointer',
	},
	bannerBg1: {
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundRepeat: 'no-repeat', 
		background: `#181E22 url(${bannerBg1})`,
	},
	saleTimerBannerContainer: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'nowrap',
		justifyContent: 'space-between',
		maxWidth: 990,
		padding: '10px 10px 0 10px',
		position: 'relative',
		zIndex: 10,
	},
	saleTimerBannerPhones: {
		width: 140,
	},
	saleTimerBannerText: {
		fontSize: 24,
		fontWeight: '700',
		lineHeight: '36px',
		color: '#ffffff',
		maxWidth: 460,
	},
	saleTimerBannerClock: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		background: '#101416',
		borderRadius: 12,
		border: '1px solid #525B60',
		margin: '0px 30px 10px',
		padding: '10px',
		color: '#ffffff',
	},
	saleTimerBannerClockItem: {
		minWidth: 70,
		minHeight: 60,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '4px 15px 2px',
		fontSize: 40,
		lineHeight: '45px',
		fontWeight: 700,
	},
	saleTimerBannerClockItemText: {
		fontSize: 12,
		fontWeight: 600,
		lineHeight: '16px',
		color: '#93999C',
		textTransform: 'lowercase',
	},
	saleTimerBannerClockItemSeparator: {
		fontSize: 20,
		fontWeight: 700,
		marginTop: '-25px',
	},
	saleTimerBannerCTA: {
		position: 'relative',
		marginBottom: 10,
		fontSize: 15,
		fontWeight: '700',
		lineHeight: '17px',
		color: '#ffffff',
		background: 'linear-gradient(90deg, #FF8F00 0%, #F86605 100%)',
		borderRadius: 12,
		padding: '15px 30px 15px 30px',
		minWidth: 150,
		textAlign: 'center',
		overflow: 'hidden',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			inset: 0,
			background: 'linear-gradient(90deg, #CC7200 0%, #C65204 100%)',
			opacity: 0,
			transition: 'opacity 0.3s ease',
			zIndex: 0,
		},
		'&:hover::before': {
			opacity: 1,
		},
		'span, &>*': {
			position: 'relative',
			zIndex: 1,
		}
	},
	bfBanner: {
		'--bf-glow': 'rgba(248, 102, 5, 0.45)',
		background: `radial-gradient(circle 180px at calc(50% - 571px) 50%, var(--bf-glow) 0%, transparent 100%), #181E22 url(${bannerBg1})`,
		backgroundSize: 'auto, cover',
		backgroundPosition: 'center, center center',
		backgroundRepeat: 'no-repeat',
		overflow: 'hidden',
	},
	bfContainer: {
		maxWidth: '100%',
		minHeight: 144,
		justifyContent: 'center',
		padding: '0.3rem 1rem',
	},
	bfText: {
		alignSelf: 'flex-end',
		maxWidth: 'none',
		flex: '0 1 auto',
		minWidth: 0,
		fontSize: 40,
		lineHeight: '48px',
		fontWeight: 800,
		'& > span': {
			alignSelf: 'center',
			marginLeft: 16,
		},
	},
	bfGift: {
		display: 'block',
		width: 'auto',
		height: 144,
	},
	bfEyebrow: {
		display: 'block',
		fontSize: 13,
		lineHeight: '15px',
		fontWeight: 700,
		letterSpacing: '0.1em',
		textTransform: 'uppercase',
		color: '#FF8F00',
		marginBottom: 4,
	},
	bfPrice: {
		background: 'linear-gradient(180deg, #FFB673 0%, #FF7A00 70%, #FF7A00 100%)',
		WebkitBackgroundClip: 'text',
		backgroundClip: 'text',
		WebkitTextFillColor: 'transparent',
		color: '#FF8F00',
		fontWeight: 800,
	},
	bfClock: {
		margin: '0 0 0 48px',
		minWidth: 347,
		minHeight: 100,
		background: 'rgba(16, 20, 22, 0.8)',
		border: '1px solid #3A4146',
		'& > div': {
			fontSize: 48,
			lineHeight: '52px',
			fontVariantNumeric: 'tabular-nums',
		},
		'& $saleTimerBannerClockItem': {
			width: 96,
			minWidth: 96,
			padding: '4px 0 2px',
		},
		'& span + span': {
			fontSize: 14,
			lineHeight: '18px',
		},
	},
	bfCTA: {
		margin: '0 0 0 72px',
		minWidth: 138,
		padding: '19px 30px',
		whiteSpace: 'nowrap',
		flexShrink: 0,
	},
	cmBanner: {
		'--bf-glow': 'rgba(40, 215, 153, 0.45)',
	},
	cmEyebrow: {
		color: '#28D799',
	},
	cmPrice: {
		background: 'linear-gradient(180deg, #89E9C7 0%, #28D799 70%, #28D799 100%)',
		WebkitBackgroundClip: 'text',
		backgroundClip: 'text',
		WebkitTextFillColor: 'transparent',
		color: '#28D799',
	},

	'@media (max-width: 1099px)': {
		bfBanner: {
			background: `radial-gradient(circle 180px at calc(50% - 251px) 50%, var(--bf-glow) 0%, transparent 100%), #181E22 url(${bannerBg1})`,
		},
		bfContainer: {
			flexWrap: 'wrap',
			justifyContent: 'center',
			paddingBottom: 12,
			columnGap: 32,
		},
		bfText: {
			flexBasis: '100%',
			justifyContent: 'center',
		},
		bfClock: {
			margin: 0,
		},
		bfCTA: {
			marginLeft: 0,
			margin: 16,
		},
	},
	'@media (max-width: 991px)': {
		bfBanner: {
			background: `radial-gradient(circle 180px at calc(50% - 191px) 50%, var(--bf-glow) 0%, transparent 100%), #181E22 url(${bannerBg1})`,
		},
		saleTimerBannerContainer: {
			justifyContent: 'center'
		},
		saleTimerBannerText: {
			fontSize: 20,
		},
		textGreen: {
			fontSize: 32,
		},
		saleTimerBannerClockItem: {
			fontSize: 36,
		},
		bfText: {
			fontSize: 30,
			lineHeight: '38px',
		},
		bfClock: {
			minWidth: 0,
			margin: 0,
			'& > div': {
				fontSize: 36,
				lineHeight: '45px',
			},
			'& $saleTimerBannerClockItem': {
				width: 76,
				minWidth: 76,
			},
		},
	},
	'@media (max-width: 800px)': {
		bfBanner: {
			background: `radial-gradient(circle 180px at calc(50% - 151px) 50%, var(--bf-glow) 0%, transparent 100%), #181E22 url(${bannerBg1})`,
		},
		saleTimerBannerContainer: {
			flexDirection: 'column',
			paddingBottom:	'12px',
		},
		bfText: {
			alignSelf: 'center',
			fontSize: 24,
			lineHeight: '30px',
			whiteSpace: 'normal',
			'& > span': {
				marginLeft: 8,
			},
		},
		bfGift: {
			width: 120,
			height: 'auto',
			flexShrink: 0,
		},
		bfClock: {
			margin: '0 0 12px',
		},
	}
});